import {
  OpenModalAuthenticate,
  openModalAuthenticateLedger,
  openModalAuthenticateSignature,
} from 'state/actions/modalActions';
import WalletIconSignature from 'components/Common/Icons/WalletIcons/WalletIconSignature';
import WalletIconLedger from 'components/Common/Icons/WalletIcons/WalletIconLedger';
import { ServerSignatureType, UserWalletType } from 'types/user';
import { DropdownOption } from 'types/common';
import AvatarOne from 'components/Common/Icons/Avatar/AvatarOne';
import AvatarTwo from 'components/Common/Icons/Avatar/AvatarTwo';
import AvatarThree from 'components/Common/Icons/Avatar/AvatarThree';
import AvatarFour from 'components/Common/Icons/Avatar/AvatarFour';
import AvatarFive from 'components/Common/Icons/Avatar/AvatarFive';
import AvatarSix from 'components/Common/Icons/Avatar/AvatarSix';
import AvatarSeven from 'components/Common/Icons/Avatar/AvatarSeven';
import AvatarEight from 'components/Common/Icons/Avatar/AvatarEight';
import AvatarNine from 'components/Common/Icons/Avatar/AvatarNine';
import AvatarTen from 'components/Common/Icons/Avatar/AvatarTen';
import TransportWebUSB from '@ledgerhq/hw-transport-webusb';

export const LS_AUTH_DATA_KEY = '041cf03294173ae10a7d993d32c9927513e191ad';

export const LS_THEME_DATA_KEY = 'theme';

export const LS_USER_SEEN_PAPERCUPS = '052ch04284278uu42a7d993d32c7728503h161ar';

export const LEDGER_PATH = "m/44'/461'/0'/0/0";

export const HAS_SEEN_INITIAL_FILMINE_ADDRESS_POPUP = 'hasSeenInitialFilmineAddressPopup';

export const AUTHENTICATION_WALLET_ICONS = {
  [UserWalletType.Signature]: WalletIconSignature,
  [UserWalletType.Ledger]: WalletIconLedger,
};

type AuthenticationModalWallets = {
  [key in UserWalletType]: {
    serverSignatureType: ServerSignatureType;
    labelTranslationKey: string;
    descriptionTranslationKey: string;
    handleClick: OpenModalAuthenticate;
    checkSupported: () => Promise<boolean>;
  };
};

const checkLedgerSupported = (): Promise<boolean> => TransportWebUSB.isSupported();

export const AUTHENTICATION_MODAL_WALLETS: AuthenticationModalWallets = {
  [UserWalletType.Signature]: {
    serverSignatureType: ServerSignatureType.Signature,
    labelTranslationKey: 'lotusLabel',
    descriptionTranslationKey: 'lotusDescription',
    handleClick: openModalAuthenticateSignature,
    checkSupported: () => new Promise((resolve) => resolve(true)),
  },
  [UserWalletType.Ledger]: {
    serverSignatureType: ServerSignatureType.Ledger,
    labelTranslationKey: 'ledgerLabel',
    descriptionTranslationKey: 'ledgerDescription',
    handleClick: openModalAuthenticateLedger,
    checkSupported: checkLedgerSupported,
  },
};

export const SIGNATURE_TYPE_TO_WALLET_TYPE_MAP = {
  [ServerSignatureType.Signature]: UserWalletType.Signature,
  [ServerSignatureType.Ledger]: UserWalletType.Ledger,
};

export const COLOR_OPTIONS: DropdownOption[] = [
  { value: '0', label: 'green/pink' },
  { value: '1', label: 'pink/green' },
  { value: '2', label: 'gray/pink' },
  { value: '3', label: 'gray/green' },
  { value: '4', label: 'gray/gray' },
  { value: '5', label: 'green/black' },
  { value: '6', label: 'pink/black' },
];

export const LIST_OF_AVATARS = [
  {
    Icon: AvatarOne,
  },
  {
    Icon: AvatarTwo,
  },
  {
    Icon: AvatarThree,
  },
  {
    Icon: AvatarFour,
  },
  {
    Icon: AvatarFive,
  },
  {
    Icon: AvatarSix,
  },
  {
    Icon: AvatarSeven,
  },
  {
    Icon: AvatarEight,
  },
  {
    Icon: AvatarNine,
  },
  {
    Icon: AvatarTen,
  },
];
